import React from 'react';

import { Navigate, useLocation } from 'react-router-dom';
import { useUser } from '../../UserContext';
import ExploreFeed from '../../compos/AllPosts/ExploreFeed';
function Explore() {
	const { user, isAuthLoading } = useUser();
	const location = useLocation();

	if (isAuthLoading) {
		return (
			<div className='flex justify-center items-center h-screen'>
				<div className='animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-[#022c56]'></div>
			</div>
		);
	}

	if (user == null) {
		return (
			<div>
				<Navigate to='/login' state={{ from: location.pathname }} />
			</div>
		);
	}

	return (
		<div>
			<ExploreFeed />
		</div>
	);
}

export default Explore;
